<template>
  <!-- 网点管理 -->
  <div class="page-container">
    <div class="page-top-tool">
      <!-- <el-button v-if="userPrower == '1'" type="success" icon="el-icon-plus" size="mini" @click="toAddStorePage">新增记录</el-button> -->
      <div class="right-search">
        <span style="margin-left: 20px;">公司名称：</span>
        <el-input v-model="info_name" clearable placeholder="请输入公司名称" :disabled="loading" size="mini" style="width: 230px;"></el-input>
        <span style="margin-left: 20px;">会员姓名：</span>
        <el-input v-model="user_name" clearable placeholder="请输入会员姓名" :disabled="loading" size="mini" style="width: 230px;"></el-input>
        <el-button type="primary" icon="el-icon-search" size="mini" :disabled="loading" style="margin-left: 20px;" @click="onSearch">搜索</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      v-loading="loading"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
      style="width: 100%; font-size: 12px; margin: 20px 0px;"
      :header-cell-style="tableHeaderColor"
    >
      <el-table-column prop="finance_no" label="订单编号" width=""></el-table-column>
      <el-table-column prop="pay_phone" label="手机号" width=""></el-table-column>
      <el-table-column prop="user_name" label="会员姓名" width="80"></el-table-column>
      <el-table-column label="开通版本" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.payment_type == '1'"  type="warning" size="mini">个人版</el-tag>
          <el-tag v-else-if="scope.row.payment_type == '2'" type="success" size="mini">团队版</el-tag>
          <el-tag v-else-if="scope.row.payment_type == '3'" size="mini">专属版</el-tag>
          <el-tag v-else-if="scope.row.payment_type == '4'" size="mini">企业版</el-tag>
          <el-tag v-else-if="scope.row.payment_type == '5'" size="mini">一级代理</el-tag>
          <el-tag v-else-if="scope.row.payment_type == '6'" size="mini">二级代理</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="payment_amount" label="付款金额" width="80">
        <template slot-scope="scope">
          ￥ {{ scope.row.payment_amount / 100 }} 元
        </template>
      </el-table-column>
      <el-table-column prop="payment_time" label="付款时间" width=""></el-table-column>
      <el-table-column label="付款方式" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.payment_method == '1'" size="mini">支付宝</el-tag>
          <el-tag v-else-if="scope.row.payment_method == '2'" size="mini">微信</el-tag>
          <el-tag v-else-if="scope.row.payment_method == '3'" size="mini">对公转账</el-tag>
          <el-tag v-else-if="scope.row.payment_method == '4'" size="mini">现金</el-tag>
          <el-tag v-else-if="scope.row.payment_method == '5'" size="mini">第三方支付</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="付款状态" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.payment_status == '1'" type="warning" size="mini">待付款</el-tag>
          <el-tag v-else-if="scope.row.payment_status == '2'" type="success" size="mini">已付款</el-tag>
          <el-tag v-else-if="scope.row.payment_status == '3'" type="info" size="mini">已关闭</el-tag>
          <el-tag v-else-if="scope.row.payment_status == '4'" type="danger" size="mini">已退款</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="开票状态" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.invoice_status == '1'" type="warning" size="mini">待开票</el-tag>
          <el-tag v-else-if="scope.row.invoice_status == '2'" type="warning" size="mini">开票中</el-tag>
          <el-tag v-else-if="scope.row.invoice_status == '3'" type="success" size="mini">已开票</el-tag>
          <el-tag v-else-if="scope.row.invoice_status == '4'" type="danger" size="mini">开票失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="订单状态" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == '1'" type="success" size="mini">正常</el-tag>
          <el-tag v-else-if="scope.row.status == '2'" type="warning" size="mini">申请作废</el-tag>
          <el-tag v-else-if="scope.row.status == '3'" type="info" size="mini">已作废</el-tag>
        </template>
      </el-table-column>
      <el-table-column v-if="userPrower == '1'" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="mini" icon="el-icon-view" @click="showDetail(scope.row)">查看详情</el-button>
          <el-button type="text" size="mini" @click="onUpdate(scope)">开票</el-button>
          <!-- <el-button type="text" size="mini" icon="el-icon-delete" @click="onDelete(scope)">作废</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
    :current-page.sync="currentPage"
    :page-size="pageSize"
    hide-on-single-page
    background
    layout="total, prev, pager, next"
    :total="total"
    @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 查看活动详情 -->
    <el-dialog title="财务详情" :visible.sync="dialogDetailVisible" @close="imageDialogClose" width="75%" :show-close="true" style="margin-top: -50px;">
      <div class="active-detail" style="text-align: center;margin-top: -20px;">
        <el-descriptions class="margin-top" :column="2" border>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                订单编号
              </div>
            </template>
            <div style="width: 300px">
              {{ activeObj.finance_no }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                付款时间
              </div>
            </template>
            <div style="width: 300px;">
              {{ activeObj.payment_time }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                付款金额
              </div>
            </template>
            <div style="width: 300px">
              ￥ {{ activeObj.payment_amount / 100 }} 元
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                购买版本
              </div>
            </template>
            <div style="width: 300px">
              <span v-if="activeObj.payment_type == '1'">个人版</span>
              <span v-else-if="activeObj.payment_type == '2'">团队版</span>
              <span v-else-if="activeObj.payment_type == '4'">企业版</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                付款状态
              </div>
            </template>
            <div style="width: 300px">
              <span v-if="activeObj.payment_status == '1'">待付款</span>
              <span v-else-if="activeObj.payment_status == '2'">已付款</span>
              <span v-else-if="activeObj.payment_status == '3'">已关闭</span>
              <span v-else-if="activeObj.payment_status == '4'">已退款</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                开票状态
              </div>
            </template>
            <div style="width: 300px">
              <span v-if="activeObj.invoice_status == '1'">待开票</span>
              <span v-else-if="activeObj.invoice_status == '2'">开票中</span>
              <span v-else-if="activeObj.invoice_status == '3'">已开票</span>
              <span v-else-if="activeObj.invoice_status == '4'">开票失败</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                发票信息
              </div>
            </template>
            <div style="width: 300px">
              <div style="margin-bottom: 10px;">
                发票类型：
                <span v-if="activeObj.invoice_type == '1'">普票</span>
                <span v-if="activeObj.invoice_type == '2'">专票</span>
              </div>
              <div style="margin-bottom: 10px;">纳税人识别号：{{ activeObj.tax_id }}</div>
              <div style="margin-bottom: 10px;">发票抬头：{{ activeObj.invoice_title }}</div>
              <div style="margin-bottom: 10px;">发票编号：{{ activeObj.invoice_no }}</div>
              <div style="margin-bottom: 10px;">开票时间：{{ activeObj.invoice_time }}</div>
              <div style="margin-bottom: 10px;">开票备注：{{ activeObj.invoice_remark }}</div>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                会员信息
              </div>
            </template>
            <div style="width: 300px">
              <div style="margin-bottom: 10px;">企业编号：{{ activeObj.info_no }}</div>
              <div style="margin-bottom: 10px;">企业名称：{{ activeObj.info_name }}</div>
              <div style="margin-bottom: 10px;">会员编号：{{ activeObj.user_no }}</div>
              <div style="margin-bottom: 10px;">会员姓名：{{ activeObj.user_name }}</div>
              <div style="margin-bottom: 10px;">付款手机号：{{ activeObj.pay_phone }}</div>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                裂变信息
              </div>
            </template>
            <div style="width: 500px">
              <div style="margin-bottom: 10px;">
                销售类型：
                <span v-if="activeObj.sale_type == '1'">直推</span>
                <span v-if="activeObj.sale_type == '2'">间推</span>
              </div>
              <div style="margin-bottom: 10px;">邀请合伙人编号：{{ activeObj.p_invite_code }}</div>
              <div style="margin-bottom: 10px;">邀请合伙人佣金：{{ activeObj.salary }}</div>
              <div style="margin-bottom: 10px;">上级管理人编号：{{ activeObj.m_invite_code }}</div>
              <div style="margin-bottom: 10px;">管理人奖金佣金：{{ activeObj.team_reward }}</div>
              <div style="margin-bottom: 10px;">裂变源会员编号：{{ activeObj.from_user_no }}</div>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'StorePage',

  data() {
    return {
      userPrower: '', // 用户权限
      user_name: '', // 会员姓名
      info_name: '', // 公司名称
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      activeObj: {},
      dialogDetailVisible: false,
      baseurl: '',
    };
  },

  mounted() {
    this.baseurl = this.$baseUrl
    let userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      userInfo = JSON.parse(userInfo)
      this.userPrower = userInfo.prower
    } else {
      this.$http({
        method: 'post',
        url: 'user_exit'
      })
      this.$router.push({
        path: '/login'
      })
    }
    this.getData()
  },

  methods: {
    getData() {
      this.loading = true
      this.$http({
        method: 'post',
        url: `/finance/find?page=${this.currentPage}&pageSize=${this.pageSize}`,
        params: {
          info_name: this.info_name,
          user_name: this.user_name
        }
      })
      .then(res => {
        this.loading = false
        if (res.errno == 0) {
          const { data, page, pageSize, count } = res.data
          this.tableData = data
          this.currentPage = page
          this.pageSize = pageSize
          this.total = count
        } else {
          this.$message.error('查询失败')
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('服务端异常，查询失败')
        console.error('查询异常：', err.message);
      })
    },
    tableHeaderColor({row, column, rowIndex, columnIndex}) {
      return 'background-color: #F2F2F2;color:#101010;'
    },
    onSearch() {
      this.currentPage = 1
      this.getData()
    },
    toAddStorePage() {
      this.$router.push({
        path: '/addFinance'
      })
    },
    // 页码改变
    handleCurrentChange(page) {
      this.currentPage = page
      this.getData()
    },
    // 查看名片详情
    showDetail(row) {
      this.activeObj = row
      this.dialogDetailVisible = true
    },
    onUpdate(scope) {
      sessionStorage.setItem('updateFinance', JSON.stringify(scope.row))
      this.$router.push({
        path: '/updateFinance',
        query: {
          id: scope.row.id
        }
      })
    },
    onDelete(scope) {
      this.$confirm(`确定要作废该记录吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            method: 'post',
            url: '/finance/update',
            params: {
              id: scope.row.id,
              status: '3'   
            }
          })
          .then(res => {
            if (res.errno == 0) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error('服务端异常，网点删除失败')
            }
          })
          .catch(err => {
            this.$message.error('服务端异常，网点删除失败')
          })
        }).catch(() => {});
    },
    // 查看图片弹框关闭
    imageDialogClose() {
      this.activeObj = {}
      this.dialogDetailVisible = false
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  background: #fff;
  height: 100%;
  width: 100%;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 20px 25px;
  overflow-y: scroll;

  .page-top-tool {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
  }
}

/* 修改滚动条样式 */
.page-container::-webkit-scrollbar {
	width: 4px;
}
.page-container::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

.active-detail {
  position: relative;
  .shenpi-resuilt-img {
    position: absolute;
    width: 120px;
    top: -70px;
    right: 0px;
    opacity: 0.6;
  }

  .active-images-layout {
    display: flex;
    flex-wrap: wrap;
    .active-images-item {
      margin: 20px;
      cursor: pointer;
    }
  }
}

.active-detail-dialog {
  height: 480px;
  overflow-y: scroll;
}
.active-detail-dialog-bottom {
  margin-top: 20px;
  text-align: right;
}

/* 修改滚动条样式 */
.active-detail-dialog::-webkit-scrollbar {
	width: 4px;
}
.active-detail-dialog::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

.copy-link {
  margin-left: 10px;
  color: #409EFF;
}
.copy-link:hover {
  cursor: pointer;
}
.url-style {
  text-decoration: none;
  color: #409EFF;
}
</style>